import { IStore } from 'store/types';

export const selectInvite = (state: IStore) => state?.invite;
